import React from 'react';

var MainTitle = React.createClass({
    render: function(){
      return(
            <div className="main__title clearfix">
              <div className="title">
                <h5><i className="fa fa-book"></i> <span>Design Library</span></h5>
              </div>
            </div>
        );
    }
});

export {MainTitle};


/** WEBPACK FOOTER **
 ** ./html/components/MainTitle.jsx
 **/